import React, { useEffect, useState } from "react";
import {
  SlSelect,
  SlOption,
  SlIcon,
  SlDrawer,
} from "@shoelace-style/shoelace/dist/react";
import NoDataFound from "../../shared/NoDataFound";
import TableLoader from "../../shared/TableLoader";
import api from "../../services/api";
import { useNavigate } from "react-router";
import {
  roles,
  languageOptions,
  stateOptions,
  BACKFILL_GAM_INTERNAL_OPTIONS,
  getBackfillGamPageLabel,
} from "../../utils/constants";
import "react-json-view-lite/dist/index.css";
import filterSvg from "../../assets/images/filter.svg";
import diamondLang from "../../assets/images/diamond_lang.svg";


import SeriAlSvg from "../../assets/images/serial_no_icon.svg";

const Slots = {
  0: "A",
  1: "B",
  2: "C",
};

function Placements() {
  const [adData, setAdData] = useState({});
  const [loader, setLoader] = useState(false);

  const [adCounts, setAdCounts] = useState({
    panel: 0,
    gam: 0,
    backfill: 0,
  });
  const [currentPage, setCurrentPage] = useState(0);
  const [langfilter, setLangFilter] = useState("1");
  const [statefilter, setStatefilter] = useState(-1);
  const [districtselect, setSelectdistrict] = useState(-1);
  const [districtfilter, setDistrictfilter] = useState([]);
  const [selectCostituency, setSelectedConstituency] = useState(-1);
  const [constituencyfilter, setConstituencyfilter] = useState([]);
  const [zoneOptions, setZoneOptions] = useState([]);
  const [selectedZone, setSelectedZone] = useState(-1);  
  const [scheduled, setScheduled] = useState(false)
  const [target_filter, setTarget_filter] = useState({
    lang_id: "1",
    state_id: "-1",
    district_id: "-1",
    constituency_id: "-1",
    zone_id: -1,
  });
  const [showFilter, setShowFilter] = useState(false);
  const navigate = useNavigate();
  const [allPositions, setAllPositions] = useState(false);
  const [selectedPosition, setSelectedPosition] = useState();

 const LanguageFilterChange = async (e) => {
    setLangFilter(e.target.value);
    setDistrictfilter([]);
    setConstituencyfilter([]);
    setCurrentPage(0);
    setTarget_filter({
      lang_id: e.target.value,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1,
    });
    fetchAds(currentPage, {
      lang_id: e.target.value,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1,
    });
    fetchZonesByLang(e.target.value);
    if (parseInt(e.target.value) === -1) {
      setStatefilter(-1);
      setLangFilter(-1);
      setSelectdistrict(-1);
      setSelectedConstituency(-1);
      setSelectedZone(-1);
    }
  };

  const fetchZonesByLang = async (lang_id) => {
    try {
    let zoneOptions = await api({
      url: "/location/getZones",
      method: "POST",
      responseType: "json",
      data: { lang_id },
    });
    if(zoneOptions?.code === 200){
      let zoneOptionsArr = [];
      for await (let item of zoneOptions.data || []) {
        const temp = { value: item.zone_id, label: `${item.zone_name}` };
        zoneOptionsArr.push(temp);
      }
        setZoneOptions(zoneOptionsArr);
    } else {
        setZoneOptions([]);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const ZoneFilterChange = async (value) => {
    setSelectedZone(value);
    setStatefilter(-1);
    setSelectdistrict(-1);
    setSelectedConstituency(-1)
    setTarget_filter({
      lang_id: target_filter.lang_id,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: value,
    });

    fetchAds(currentPage, {
      lang_id: target_filter.lang_id,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: value,
    });
  };
  const StateFilterChange = async (value) => {
    setStatefilter(value);
    setConstituencyfilter([]);
    if (parseInt(value) !== -1) {
      try {
        let res = await api({
          url: "/location/getDistrictsByStateId",
          method: "POST",
          responseType: "json",
          data: { states: [value], langs: [langfilter] },
        });
        let districts = [];
        for await (let item of res.data) {
          const temp = { value: item, label: `${item.dist_name}` };
          districts.push(temp);
        }
        setDistrictfilter(districts);
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
    if (parseInt(value) === -1) {
      setSelectdistrict(-1);
      setStatefilter(-1);
      setSelectedConstituency(-1);
    }
    setTarget_filter({
      lang_id: target_filter.lang_id,
      state_id: value,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1
    });
    fetchAds(currentPage, {
      lang_id: target_filter.lang_id,
      state_id: value,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1
    });
  };

  const DistrictFilterChanger = async (value) => {
    setSelectdistrict(value);
    setConstituencyfilter([]);
    if (parseInt(value) !== -1) {
      try {
        let res = await api({
          url: "/location/getConstituentsnew",
          method: "POST",
          responseType: "json",
          data: { districts: [value], langs: [langfilter] },
        });
        let mandals = [];
        for await (let item of res.data) {
          const temp = { value: item, label: `${item.const_name}` };
          mandals.push(temp);
        }
        setConstituencyfilter(mandals);
      } catch (error) {
        console.error(error);
        if (error.response.status === 401) navigate("/");
      }
    }
    if (parseInt(value) === -1) {
      setSelectdistrict(-1);
      setSelectedConstituency(-1);
    }
    setTarget_filter({
      district_id: value,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
      constituency_id: -1,
      zone_id: -1
    });
    fetchAds(currentPage, {
      district_id: value,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
      constituency_id: -1,
      zone_id: -1
    });
  };

  const constituencyFilterChange = async (value) => {
    setSelectedConstituency(value);
    setTarget_filter({
      district_id: target_filter.district_id,
      constituency_id: value,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
      zone_id: -1
    });
    fetchAds(currentPage, {
      district_id: target_filter.district_id,
      constituency_id: value,
      state_id: target_filter.state_id,
      lang_id: target_filter.lang_id,
      zone_id: -1
    });
  };



  const fetchAds = async (
    page = 0,
    target_filter = {
      lang_id: 1,
      state_id: -1,
      district_id: -1,
      constituency_id: -1,
      zone_id: -1,
    }
  ) => {
    setLoader(true);
    try {
      let res = await api({
        url: "/lineItem-placement/getPlacementLineItems",
        method: "POST",
        responseType: "json",
        data: { target_filter,scheduled },
      });
      if (res.code === 200) {
        if (res.data) setAdData(res.data);
        setLoader(false);
      } else {
        setLoader(false);
      }
    } catch (error) {
      console.error(error);
    }
  };

  function handleRequestClose(event) {
    if (event.detail.source === "overlay") {
      event.preventDefault();
    }
  }
  useEffect(() => {
    fetchAds(currentPage,target_filter);
  }, [scheduled]);

  function hasNonEmptyArray(data) {
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const obj = data[key];
        for (const subKey in obj) {
          if (subKey !== "rotation" && subKey !== "villageAdIds") {
            if (Array.isArray(obj[subKey]) && obj[subKey].length > 0) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  function hasNonEmptyArraybackfill(data) {
    for (const key in data) {
      if (data.hasOwnProperty(key) && key !== '3') {
        const obj = data[key];
        for (const subKey in obj) {
          if (subKey !== "rotation" && subKey !== "villageAdIds") {
            if (Array.isArray(obj[subKey]) && obj[subKey].length > 0) {
              return true;
            }
          }
        }
      }
    }
    return false;
  }
  function hasSlotData(obj) {
    return Object.keys(obj).some((key) => {
      if (Array.isArray(obj[key]) && key !== "villageAdIds") {
        return obj[key].length >= 1;
      }
      return false;
    });
  }
  const scrollToSection = (id) => {
    document.getElementById(id).scrollIntoView({ behavior: "smooth" });
  };
  const getPositionClassName = (data) => {
    const order = ['langAdIds', 'stateAdIds', 'districtAdIds', 'constituencyAdIds', 'gamAds', 'backfillAds'];
    let classes = new Set();
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        const obj = data[key];
        
        for (const subKey in obj) {
          if (subKey !== "rotation" && Array.isArray(obj[subKey]) && obj[subKey].length > 0) {
            if(subKey !== 'villageAdIds')
              classes.add(subKey);
          }
        }
      }
    }
  
    if (classes.size === 0) {
      return '';
    }
  
    if (classes.size > 1) {
      let orderedClasses = [...classes].sort((a, b) => order.indexOf(a) - order.indexOf(b));
      let availableColors =orderedClasses.map((color) => {
        return color === 'langAdIds' ? '#15803D' :
               color === 'stateAdIds' ? '#8200be' :
               color === 'districtAdIds' ? '#EA580C' :
               color === 'constituencyAdIds' ? '#2563EB' :
               color === 'gamAds' ? '#d58e00' :
               color === 'backfillAds' ? '#E879F9' : '';
      }).filter(Boolean);  // Remove any empty strings
  
      if (availableColors.length > 1) {
        const colorStops = availableColors.map((color, index) => {
          return `${color} ${(index * 100) / availableColors.length}%, ${color} ${(index + 1) * 100 / availableColors.length - 1}%`;
        }).join(', ');

        const gradientString = `linear-gradient(to right, ${colorStops})`;
        const stripeString = `repeating-linear-gradient(to right, white 0, white 1px, transparent 1px, transparent 2px)`;
      return `${gradientString}, ${stripeString}`
      } else {
        return '';
      }
    } else {
      let val = classes.values().next().value;
      return `active ${val === 'langAdIds' ? 'lang' :
                      val === 'stateAdIds' ? 'state' :
                      val === 'districtAdIds' ? 'dist' :
                      val === 'constituencyAdIds' ? 'mand' :
                      val === 'gamAds' ? 'gam' :
                      val === "backfillAds" ? "backfill" : ""}`;
    }
  };
  const SlotLength = Array.from({ length: 3 });

  const handleScheduled = () =>{
      setScheduled(prev => !prev)
  }

  useEffect(() => {
    if(langfilter !== -1)
      fetchZonesByLang(+langfilter);
  }, []);

  return (
    <>
    <div className="adUnitStickyHead">
      <h5>Placements</h5>
      <div className="d-flex gap-3 justify-content-end ml-auto mobileNegFil">
        <div className="flex items-center gap-3 ">
          <aside className="flex items-center gap-3 justify-center mobHide">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                checked={scheduled}
                onChange={handleScheduled}
                id="schedule"
              />
              <label className="form-check-label" htmlFor="schedule">
                Show Scheduled
              </label>
            </div>
            {localStorage.getItem("role") !== roles.advertiser &&
              localStorage.getItem("role") !== roles.salesperson}

            {localStorage.getItem("role") !== roles.advertiser &&
              localStorage.getItem("role") !== roles.salesperson && (               
                <div>                
                  <SlSelect
                    placeholder="Select Language"
                    name="lang"
                    size="small"
                    onSlChange={LanguageFilterChange}
                    value={langfilter}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    {/* <SlOption value="-1">All</SlOption> */}
                    {languageOptions.map((item) => {
                      return (
                        <SlOption key={item.value} value={item.value}>
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}{
                langfilter !== -1 && statefilter === -1 && (
                  <div>
                    <SlSelect
                      placeholder="Select Zone"
                      name="zone"
                      size="small"
                      onSlChange={(e) => {
                        ZoneFilterChange(e.target.value);
                      }}
                    >
                      <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                      <SlOption value="-1">All</SlOption>
                      {zoneOptions.map((item) => {
                        return (
                          <SlOption key={item.value} value={item.value}>
                            {item.label}
                          </SlOption>
                        );
                      })}
                    </SlSelect>
                  </div>
                )
              }  
              { +selectedZone === -1 ? <>
            {langfilter !== -1 && (
              <div>
                <SlSelect
                  placeholder="Select State"
                  name="state"
                  size="small"
                  onSlChange={(e) => {
                    setSelectedZone(-1);
                    StateFilterChange(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {stateOptions
                    .filter((item) => item.lang_id === +langfilter)
                    .map((item) => {
                      return (
                        <SlOption key={item.state_id} value={item.state_id}>
                          {item.state_name}
                        </SlOption>
                      );
                    })}
                </SlSelect>
              </div>
            )}
            {statefilter !== -1 && (
              <div>
                <SlSelect
                  placeholder="Select District"
                  name="district"
                  size="small"
                  onSlChange={(e) => {
                    DistrictFilterChanger(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {districtfilter.map((item) => {
                    return (
                      <SlOption
                        key={item.value.dist_id}
                        value={item.value.dist_id}
                      >
                        {item.label}
                      </SlOption>
                    );
                  })}
                </SlSelect>
              </div>
            )}

            {districtselect !== -1 && (
                <div>
                  <SlSelect
                    placeholder="Select Constituency"
                    name="Constituency"
                    size="small"
                    onSlChange={(e) => {
                      constituencyFilterChange(e.target.value);
                    }}
                  >
                    <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                    <SlOption value="-1">All</SlOption>
                    {constituencyfilter.map((item) => {
                      return (
                        <SlOption
                          key={item.value.const_id}
                          value={item.value.const_id}
                        >
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}
  
            </> : null}
          </aside>
          <img
            src={filterSvg}
            onClick={() => setShowFilter(true)}
            alt="filter"
            className="mobileOnly ml-auto"
          ></img>
        </div>
      </div>

      <div id="filterRadios">
        <h6>Positions</h6>
        <div class="r-contain">
          <input
            type="radio"
            name="radio"
            id="radio2"
            defaultChecked={!allPositions}
            onClick={() => {
              setAllPositions(false);
            }}
          />
          <label for="radio2">Show Active Only</label>
        </div>
        <div class="r-contain">
          <input
            type="radio"
            name="radio"
            id="radio1"
            defaultChecked={allPositions}
            onClick={() => {
              setAllPositions(true);
            }}
          />
          <label for="radio1">All Positions</label>
        </div>
       
      </div>
      <div class="posList">
        <ul>
          {Object.keys(adData).map((item, indexMain) => {
            return hasNonEmptyArray(adData[item]) || allPositions ? (
              <li
              style={{backgroundImage: getPositionClassName(adData[item]) ,backgroundRepeat:"no-repeat",  backgroundSize: 'cover'}} className={ getPositionClassName(adData[item]).includes('linear') ? 'active' : getPositionClassName(adData[item]) }
                onClick={() => {scrollToSection(`ad-${indexMain}`); setSelectedPosition(indexMain)}}
                key={indexMain}
              >
                {indexMain}
              </li>
            ) : null;
          })}
        </ul>
      </div>
      </div>
      <div className="my-2 p-1">
        
          <div className="placements-container">
            {!loader && Object.keys(adData)?.length ? (
              Object.keys(adData).map((item, indexMain) => {
                return hasNonEmptyArray(adData[item]) || allPositions ? (
                  <>
                    <div
                      id={`ad-${indexMain}`}
                      className={`plmnts-card ${
                        selectedPosition === indexMain ? "active" : ""
                      }`}
                      key={indexMain}
                    >
                      <div className="posNum">
                        <img src={SeriAlSvg} alt="Position Number" />
                        <span>{item}</span>
                      </div>

                      <div className="tblCol langCol">
                        <div class="title">Panel Ads / GAM Internal Ads</div>
                        {hasNonEmptyArraybackfill(adData[item]) ? (
                          <div className="d-flex flex-col self-stretch h-full mobFull">

                            <div className="posHead">
                              <h4 className="language">
                                <img src={diamondLang} alt="" />{" "}
                                <span>Language</span>
                              </h4>                            
                              <h4 className="state">
                                <img src={diamondLang} alt="" />{" "}
                                <span>State</span>
                              </h4>
                              <h4 className="district">
                                <img src={diamondLang} alt="" />{" "}
                                <span>District</span>
                              </h4>
                              <h4 className="zone">
                                <img src={diamondLang} alt="" />{" "}
                                <span>Zone</span>
                              </h4>
                              <h4 className="mandal">
                                <img src={diamondLang} alt="" />{" "}
                                <span>Constituency</span>
                              </h4>
                            </div>


                            {SlotLength.map((slot, index) => {
                              return hasSlotData(adData[item][index]) ? (
                                <div class="pgAds">
                                  <ul className="slot"><span>{Slots[index]}</span></ul>

                                  {adData[item][index]["langAdIds"].length >
                                  0 ? (
                                    <ul class="language">
                                      {adData[item][index]["langAdIds"].map(
                                        (campaign, index) => {
                                          return (
                                            <li key={campaign.id}>
                                              {campaign.campaign_name}
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  ) : <ul className="desktopOnly text-center"><span>-</span></ul>}
                                  
                                  {adData[item][index]["stateAdIds"].length >
                                  0 ? (
                                    <ul class="state">
                                      {adData[item][index]["stateAdIds"].map(
                                        (campaign, index) => {
                                          return (
                                            <li key={campaign.id}>
                                              {campaign.campaign_name}
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  ) : <ul className="desktopOnly text-center"><span>-</span></ul>}

                                  {adData[item][index]["districtAdIds"].length >
                                  0 ? (
                                    <ul class="district">
                                      {adData[item][index]["districtAdIds"].map(
                                        (campaign, index) => {
                                          return (
                                            <li key={campaign.id}>
                                              {campaign.campaign_name}
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  ) : <ul className="desktopOnly text-center"><span>-</span></ul>}
                                  {adData[item][index]["zoneAdIds"]?.length >
                                  0 ? (
                                    <ul class="zone">
                                      {adData[item][index]["zoneAdIds"].map(
                                        (campaign, index) => {
                                          return (
                                            <li key={campaign.id}>
                                              {campaign.campaign_name}
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  ) : <ul className="desktopOnly text-center"><span>-</span></ul>}
                                  {adData[item][index]?.["constituencyAdIds"]?.length >
                                  0 ? (
                                    <ul class="mandal">
                                      {adData[item][index]?.["constituencyAdIds"]?.map(
                                        (campaign, index) => {
                                          return (
                                            <li key={campaign.id}>
                                              {campaign.campaign_name}
                                            </li>
                                          );
                                        }
                                      )}
                                    </ul>
                                  ) : <ul className="desktopOnly text-center"><span>-</span></ul>}
                                </div>
                              ) : null;
                            })}
                          </div>
                        ) : (
                          <p className="noData">No Data Available</p>
                        )}
                      </div>
                      <div class="tblCol gamAds">
                      <div class="title">
                              <span>GAM Network Ads</span>
                            </div>
                        {adData[item][3]["gamAds"].length !== 0 ? (
                          <>
                          {
                            adData[item][3]["gamAds"].map(gamAd => (
                        <ul class="mandal">
                           <li><span>AdName:</span>{gamAd.ad_name}</li>
                            <li><span>AdCode:</span>{gamAd.ad_code}</li>
                            <li><span>BannerCode:</span> {gamAd.banner_code}</li>
                            <li><span>Otheradcode:</span> {gamAd.other_ad_code}</li>
                        </ul>
                            ))
                          }
                           
                           
                          </>
                        ) : (
                          <p className="noData">---</p>
                        )}
                      </div>
                      <div class="tblCol bkFill">
                        <div class="title">Backfill</div>
                        <div class="pgAds">
                          <ul>
                            {adData[item][3]["backfillAds"].map(item => <li>
                              {
                                item?.campaign_name || "-"}
                            </li>)}
                          </ul>
                        </div>
                        {adData[item][3]["widgetAds"]?.filter(w => w.view).length ? (
                          <div className="text-xs">
                            <ul>
                              {adData[item][3]["widgetAds"]?.filter(w => w.view)?.map(w => {
                                const opt = BACKFILL_GAM_INTERNAL_OPTIONS.find(o => o.value === w?.widget_type);
                                const pageLabel = getBackfillGamPageLabel(w?.page, w?.widget_type);
                                return <div className="text-xs flex flex-wrap gap-1 my-1 p-0.5" key={w?.widget_type}><span className="text-blue-600">{opt?.label}</span><span>({pageLabel})</span></div>;
                              })}
                            </ul>
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </>
                ) : null;
              })
            ) : !Object.keys(adData)?.length && !loader ? (
              <NoDataFound colspan="5" />
            ) : (
              <div class="flex items-center gap-3 p-4 w-full justify-center">
  <span class="text-lg font-semibold">
    వస్తున్నా… యాడ్ డీటెయిల్స్ తెస్తున్నా<span class="text-gray-400">…</span>
  </span>

  <span class="flex items-end gap-1">
    <span class="h-2 w-2 rounded-full bg-gray-300 animate-bounce [animation-delay:-0.2s]"></span>
    <span class="h-2 w-2 rounded-full bg-gray-600 animate-bounce [animation-delay:-0.1s]"></span>
    <span class="h-2 w-2 rounded-full bg-black animate-bounce"></span>
  </span>
</div>


            )}
          </div>
        
      </div>
      <SlDrawer
        open={showFilter}
        onSlRequestClose={handleRequestClose}
        placement="bottom"
        noHeader
        onSlAfterHide={() => {}}
        style={{ "--size": "fit-content" }}
      >
        <div className="relative">
          <h3 className="mb-3">Apply Filters</h3>
          <hr></hr>
          <div className="flex items-center gap-3 justify-center flex-wrap">
            {localStorage.getItem("role") !== roles.advertiser &&
              localStorage.getItem("role") !== roles.salesperson}

            {localStorage.getItem("role") !== roles.advertiser &&
              localStorage.getItem("role") !== roles.salesperson && (
                <div className="w-full">
                  <SlSelect
                    placeholder="Select Language"
                    name="lang"
                    size="small"
                    onSlChange={LanguageFilterChange}
                    value={langfilter}
                  >
                    <SlIcon
                      library="lucide"
                      name="globe"
                      slot="prefix"
                    ></SlIcon>
                    {/* <SlOption value="-1">All</SlOption> */}
                    {languageOptions.map((item) => {
                      return (
                        <SlOption key={item.value} value={item.value}>
                          {item.label}
                        </SlOption>
                      );
                    })}
                  </SlSelect>
                </div>
              )}
            {langfilter !== -1 && (
              <div className="w-full">
                <SlSelect
                  placeholder="Select State"
                  name="state"
                  size="small"
                  onSlChange={(e) => {
                    StateFilterChange(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {stateOptions
                    .filter((item) => item.lang_id === +langfilter)
                    .map((item) => {
                      return (
                        <SlOption key={item.state_id} value={item.state_id}>
                          {item.state_name}
                        </SlOption>
                      );
                    })}
                </SlSelect>
              </div>
            )}
            {statefilter !== -1 && (
              <div className="w-full">
                <SlSelect
                  placeholder="Select District"
                  name="district"
                  size="small"
                  onSlChange={(e) => {
                    DistrictFilterChanger(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {districtfilter.map((item) => {
                    return (
                      <SlOption
                        key={item.value.dist_id}
                        value={item.value.dist_id}
                      >
                        {item.label}
                      </SlOption>
                    );
                  })}
                </SlSelect>
              </div>
            )}

            {districtselect !== -1 && (
              <div>
                <SlSelect
                  placeholder="Select Constituency"
                  name="Constituency"
                  size="small"
                  onSlChange={(e) => {
                    constituencyFilterChange(e.target.value);
                  }}
                >
                  <SlIcon library="lucide" name="globe" slot="prefix"></SlIcon>
                  <SlOption value="-1">All</SlOption>
                  {constituencyfilter.map((item) => {
                    return (
                      <SlOption
                        key={item.value.const_id}
                        value={item.value.const_id}
                      >
                        {item.label}
                      </SlOption>
                    );
                  })}
                </SlSelect>
              </div>
            )}
          
          </div>
          <SlIcon
            className="absolute top-1 right-1 text-2xl hover:text-red-600 cursor-pointer"
            name="x-circle"
            onClick={() => setShowFilter(false)}
          ></SlIcon>
        </div>
      </SlDrawer>
    </>
  );
}

export default Placements;
